import React, { Component } from 'react';
import './Title.css';
import Utils from '../../../base/Utils';

class Button extends Component {
    availableSizes = ['Huge', 'Big', 'Medium', 'Small'];
    availableColors = ['Normal', 'Dark', 'Light', 'Good', 'Medium', 'Bad'];
    availableTypes = ['Underlined'];
    
    render() {
        var text = this.props.text;
        var customColor = this.props.customColor;
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        var color = Utils.checkAvailability(this.availableColors, this.props.color, true);
        var type = Utils.checkAvailability(this.availableTypes, this.props.type);
        
        var classValue = "Title " + size + " " + type + " " + color;
        
        var html = <div style={{color: customColor}} className={classValue}>
        {text}
        </div>;
        
        return html;
    }
}

export default Button;
